import { BasePeerToPeerCampaignAction } from "./BasePeerToPeerCampaignAction";

import { FormButton } from "@/forms-design-system/FormButton/FormButton";
import { useTranslate } from "@/hooks/useTranslate";
import { ArrowDiagonalRight } from "@/icons/outlined";
type PeerToPeerTeamCampaignFundraiseCampaignActionProps = {
  onClick?: () => void;
};

export const PeerToPeerTeamCampaignFundraiseCampaignAction = ({
  onClick,
}: PeerToPeerTeamCampaignFundraiseCampaignActionProps) => {
  const { t } = useTranslate();

  return (
    <BasePeerToPeerCampaignAction
      title={t("donationForm", "peerToPeer.title.wantToFundraise")}
      description={t("donationForm", "peerToPeer.description.joinFundraisingTeam")}
      slots={{
        button: (
          <FormButton variant="outline" endIcon={<ArrowDiagonalRight />} onClick={onClick} data-test="fundraise-button">
            {t("donationForm", "peerToPeer.button.fundraise")}
          </FormButton>
        ),
      }}
    />
  );
};
